import { render } from "./vprintresourcesaddmore.vue?vue&type=template&id=8e8c97a4&scoped=true"
import script from "./vprintresourcesaddmore.vue?vue&type=script&lang=js"
export * from "./vprintresourcesaddmore.vue?vue&type=script&lang=js"

import "./vprintresourcesaddmore.vue?vue&type=style&index=0&id=8e8c97a4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e8c97a4"]])

export default __exports__